/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonFinancialViewModel } from "../types/PersonFinancialViewModel.ts";
import { eAccountTypeSchema } from "./eAccountTypeSchema.ts";
import { ePersonFinancialPaymentMethodSchema } from "./ePersonFinancialPaymentMethodSchema.ts";

export const personFinancialViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  bankName: z.string().nullish(),
  agency: z.string().nullish(),
  checkingAccount: z.string().nullish(),
  savingAccount: z.string().nullish(),
  paymentMethod: z.optional(
    z
      .lazy(() => ePersonFinancialPaymentMethodSchema)
      .describe(
        "1 = Colleger | 2 = Refound | 3 = CheckingAccountPayment | 4 = SavingAccountPayment | 5 = Check | ",
      ),
  ),
  accountType: z.optional(
    z
      .lazy(() => eAccountTypeSchema)
      .describe("1 = PhysicalPerson | 2 = LegalPerson | "),
  ),
}) as unknown as ToZod<PersonFinancialViewModel>;
